import {Form as MobxReactForm} from '@swipe-guide/clients-shared/utils/mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';

export const plugins = {dvr: dvr(validatorjs)};

const fields = [
  {
    name: 'searchTerm',
    rules: 'string'
  }
];

export default () => new MobxReactForm({fields}, {plugins});
